import "../scss/config.scss";
var $ = require('jquery');